<template>
  <div id="inventory-goods">
    <!-- 全屏禁用蒙层 -->
    <div v-if="submitting" class="loading-overlay"></div>
    <div class="description">
      <van-field v-model="description" label="备注" placeholder="请输入备注" />
    </div>
    <div class="">
      <van-search
        v-model:value="condition"
        show-action
        placeholder="请输入商品名称/条码"
        @search="toSearch"
        @clear="clear"
        :disabled="pageType === 'detail'"
      >
        <template #action>
          <div @click="toSearch">搜索</div>
          <van-button
            v-if="pageType !== 'detail'"
            type="primary"
            size="mini"
            :plain="!showDifferencesOnly"
            @click="toAdjust"
          >
            差异
          </van-button>
          <van-icon
            v-if="pageType !== 'detail'"
            name="scan"
            size="18px"
            @click="toScan"
          />
        </template>
      </van-search>
    </div>

    <div class="listWrapper">
      <div class="leftWrapper">
        <MenuSideBar
          ref="menuSidebar"
          :menuData="categories"
          :activeId="query.categoryId"
          @toggleChildren="clickLeft"
        />
      </div>
      <div class="rightWrapper" @scroll="handleRightScroll">
        <GlobalLoading :show="loading || cateLoading" />
        <div v-if="categoriesDetail && categoriesDetail.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="已显示全部"
            :immediate-check="false"
            @load="onLoad"
            :offset="50"
            class="productWrapper"
            ref="productWrapper"
          >
            <div v-for="(cate, index) in categoriesDetail" :key="cate.name">
              <div :id="'category-' + cate.name" class="categoryTitle fs14">
                {{ cate.name }}
              </div>
              <van-card
                v-for="(item, index) in getList(cate.products)"
                :key="item.productId + index"
                :desc="formatDesc(item)"
                :title="item.productName"
                :thumb="'https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg'"
              >
                <template #price>
                  <div class="flex flex-between">
                    <span class="price">{{ formatePrice(item) }}</span>
                    <span v-if="item.isWeigh" class="weight-badge">称</span>
                  </div>
                </template>
                <template #footer>
                  <div class="inventory-num">
                    <div class="stock-info">
                      <span class="stock-label">系统库存:</span>
                      <span class="stock-value">{{ item.stockNum || 0 }}</span>
                    </div>
                    <div class="stock-info">
                      <span class="stock-label">盘点数:</span>
                      <span class="stock-value">{{ item.inventoryNum }}</span>
                    </div>
                  </div>
                  <div v-if="pageType !== 'detail'" class="action-links">
                    <span class="action-link" @click.stop="handleAdjust(item)"
                      >盘点</span
                    >
                    <span class="divider">|</span>
                    <span
                      class="action-link delete"
                      @click.stop="handleDelete(item)"
                      >删除</span
                    >
                  </div>
                </template>
              </van-card>
            </div>
          </van-list>
        </div>
        <div v-else-if="!loading" class="emptyWrapper">暂无商品</div>
      </div>
    </div>

    <!-- 扫码弹窗 -->
    <van-popup
      v-model:show="scanDialogVisible"
      position="center"
      class="scan-popup"
    >
      <div class="scan-dialog">
        <div class="scan-icon-wrapper">
          <van-icon name="scan" size="80px" color="#1989fa" />
          <p class="scan-tip">请扫描商品条码</p>
        </div>
        <div class="scan-actions">
          <van-button block type="default" @click="closeScan">取消</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 底部操作按钮 -->
    <div class="footer-actions">
      <div class="footer-btn-group">
        <template v-if="pageType !== 'detail'">
          <van-button
            block
            type="default"
            @click="handleAddProduct"
            :disabled="cateLoading || submitting"
            >添加商品</van-button
          >
          <van-button
            block
            type="primary"
            @click="handleSave"
            :loading="submitting"
            :disabled="cateLoading || submitting"
            >保存</van-button
          >
          <van-button
            block
            type="success"
            @click="handleApprove"
            :loading="submitting"
            :disabled="cateLoading || submitting"
            >审核通过</van-button
          >
        </template>
        <van-button block type="default" @click="handleClose">关闭</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalLoading from "@/components/globalLoading";
import MenuSideBar from "@/components/menuSideBar/index";
import { get, getProducts } from "../../../service/api/stock/take/plan/index";
import {
  getDetail,
  update,
  directApprovePass,
  approvePass,
  create,
} from "../../../service/api/stock/take/index";
import { reqProduct } from "../../../service/api/product";
import _ from "lodash";

export default {
  name: "InventoryGoods",
  data() {
    return {
      pageType: "",
      sheetId: null,
      bizType: "",
      reasonId: "",
      description: "",
      categories: [{ id: 0, name: "全部" }],
      categoriesDetail: [],
      currentIndex: 0,
      query: {
        name: "",
        pageIndex: 1,
        pageSize: 20,
        available: true,
        categoryId: "",
        planId: null,
        scId: null,
      },
      condition: "",
      cateLoading: false,
      loading: false,
      finished: false,
      planId: null,
      planCode: "",
      scId: null,
      storeName: "",
      totalPage: 1,
      allProducts: [],
      showDifferencesOnly: false,
      scanDialogVisible: false,
      scanBuffer: "",
      needMerge: false,
      submitting: false,
      scrollTimer: null,
      initialProducts: [],
      deleteProductIds: [],
    };
  },
  components: {
    GlobalLoading,
    MenuSideBar,
  },
  created() {
    this.condition = "";
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.needMerge = from.path.includes("/category");
      console.log(from.path, vm.needMerge);
      vm.init();
    });
  },
  watch: {
    initialProducts: {
      handler(newVal, oldVal) {
        console.log("initialProducts", newVal);
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.pageType = this.$route.query.type || "";
      console.log("init", this.pageType);
      if (this.pageType) {
        this.sheetId = this.$route.query.sheetId;
        if (this.$route.query.planId) {
          this.planId = this.$route.query.planId;
        }
        this.getSheetDetail(this.sheetId);
      } else {
        this.planId = this.$route.query.planId;
        this.query.planId = this.planId;

        this.loadProducts(this.needMerge);
      }
    },

    getSheetDetail(sheetId) {
      console.log("getSheetDetail", sheetId);
      const planCachedStr = localStorage.getItem(this.getPlanCacheKey());
      if (planCachedStr) {
        try {
          const planData = JSON.parse(planCachedStr);

          if (planData.planCode) this.planCode = planData.planCode;
          if (planData.scId) this.scId = planData.scId;
          if (planData.storeName) this.storeName = planData.storeName;
          if (planData.planId) this.planId = planData.planId;
          if (planData.description)
            this.description = planData.description || "";

          this.allProducts = planData.allProducts || [];
          this.initialProducts = planData.initialProducts || [];
          this.cateLoading = false;

          if (this.needMerge) {
            this.mergeCategoryInventoryData();
          } else {
            this.groupProductsByCategory();
          }
          return;
        } catch (e) {
          localStorage.removeItem(this.getPlanCacheKey());
          console.warn("盘点单缓存解析失败，重新加载", e);
        }
      }

      this.cateLoading = true;
      getDetail(sheetId)
        .then((res) => {
          this.cateLoading = false;
          if (res.code === 200 && res.data) {
            this.planCode = res.data.planCode;
            this.scId = res.data.scId;
            this.storeName = res.data.scName;
            this.planId = res.data.planId;
            this.description = res.data.description || "";

            const details = res.data.details || [];
            this.allProducts = details.map((item) => ({
              ...item,
              productId: item.productId,
              productName: item.productName,
              categoryName: item.categoryName,
              categoryId: item.categoryId,
              stockNum: item.stockNum,
              inventoryNum: item.takeNum,
              productCode: item.productCode,
              skuCode: item.skuCode,
              externalCode: item.externalCode,
              spec: item.spec,
              unit: item.unit,
              brandName: item.brandName,
            }));
            this.allProducts = this.getList(this.allProducts);
            this.initialProducts = JSON.parse(JSON.stringify(this.allProducts));
            this.savePlanToCache();

            if (this.needMerge) {
              this.mergeCategoryInventoryData();
            } else {
              this.groupProductsByCategory();
            }
          } else {
            this.categoriesDetail = [];
          }
        })
        .catch(() => {
          this.cateLoading = false;
          this.categoriesDetail = [];
        });
    },

    getPlanCacheKey() {
      return `inventory_plan_${this.planId}`;
    },

    mergeCategoryInventoryData() {
      console.log("mergeCategoryInventoryData");
      const categoryCacheKey = "inventory_goods";
      const categoryStr = localStorage.getItem(categoryCacheKey);
      if (!categoryStr) {
        this.groupProductsByCategory();
        return;
      }

      let categoryProducts;
      try {
        categoryProducts = JSON.parse(categoryStr);
      } catch (e) {
        console.warn("解析category本地存储数据失败", e);
        this.groupProductsByCategory();
        return;
      }

      if (!Array.isArray(categoryProducts) || categoryProducts.length === 0) {
        this.groupProductsByCategory();
        return;
      }

      localStorage.removeItem(categoryCacheKey);

      categoryProducts.forEach((categoryItem) => {
        const categoryInventoryNum =
          categoryItem.inventoryNum === 0 || categoryItem.inventoryNum
            ? Number(categoryItem.inventoryNum)
            : "";

        const existingIndex = this.allProducts.findIndex(
          (item) => item.productId == categoryItem.productId,
        );

        if (existingIndex > -1) {
          const existingItem = this.allProducts[existingIndex];
          const currentNum =
            existingItem.inventoryNum === 0 || existingItem.inventoryNum
              ? Number(existingItem.inventoryNum)
              : "";
          const total = this.$utils.preciseAdd(
            currentNum,
            categoryInventoryNum,
          );
          this.$set(this.allProducts, existingIndex, {
            ...existingItem,
            inventoryNum: total,
          });
        } else {
          const newItem = {
            ...categoryItem,
            inventoryNum: categoryInventoryNum,
          };
          this.allProducts.push(newItem);
        }
      });

      const productMap = new Map();
      this.allProducts.forEach((item) => {
        const key = String(item.productId);
        if (!productMap.has(key)) {
          productMap.set(key, item);
        }
      });
      this.allProducts = Array.from(productMap.values());

      this.allProducts = this.getList(this.allProducts);
      this.groupProductsByCategory();

      this.savePlanToCache();
    },

    loadProducts(needMerge = false) {
      console.log("loadProducts", needMerge);
      const planCachedStr = localStorage.getItem(this.getPlanCacheKey());
      if (planCachedStr) {
        try {
          const planData = JSON.parse(planCachedStr);

          if (planData.planCode) this.planCode = planData.planCode;
          if (planData.scId) this.scId = planData.scId;
          if (planData.storeName) this.storeName = planData.storeName;
          if (planData.description)
            this.description = planData.description || "";

          this.allProducts = planData.allProducts || [];
          this.cateLoading = false;

          this.allProducts = this.getList(this.allProducts);
          console.log(this.allProducts);
          if (needMerge) {
            this.mergeCategoryInventoryData();
          } else {
            this.groupProductsByCategory();
          }
          return;
        } catch (e) {
          localStorage.removeItem(this.getPlanCacheKey());
          console.warn("完整任务缓存解析失败，重新加载", e);
        }
      }

      this.cateLoading = true;

      get(this.planId)
        .then((res) => {
          if (res.code === 200) {
            this.planCode = res.data.code;
            this.scId = res.data.scId;
            this.storeName = res.data.scName;
          }

          getProducts(this.planId)
            .then((res) => {
              this.cateLoading = false;
              if (res.code === 200) {
                this.allProducts = res.data || [];
                this.allProducts = this.getList(this.allProducts);
                if (needMerge) {
                  this.mergeCategoryInventoryData();
                } else {
                  this.groupProductsByCategory();
                }

                this.savePlanToCache();
              } else {
                this.categoriesDetail = [];
              }
            })
            .catch(() => {
              this.cateLoading = false;
              this.categoriesDetail = [];
            });
        })
        .catch((e) => {
          console.warn("获取完整任务数据失败", e);
          this.cateLoading = false;
          this.categoriesDetail = [];
        });
    },

    savePlanToCache() {
      try {
        const planData = {
          planId: this.planId,
          planCode: this.planCode,
          scId: this.scId,
          storeName: this.storeName,
          description: this.description,
          allProducts: this.allProducts,
          initialProducts: this.initialProducts,
        };
        localStorage.setItem(this.getPlanCacheKey(), JSON.stringify(planData));
      } catch (e) {
        console.warn("保存完整任务数据到本地存储失败", e);
      }
    },

    clearCache() {
      localStorage.removeItem(this.getPlanCacheKey());
    },

    groupProductsByCategory() {
      console.log("groupProductsByCategory");
      const categoryMap = new Map();
      this.allProducts.forEach((item) => {
        if (item.categoryName && item.categoryId) {
          categoryMap.set(item.categoryId, {
            id: item.categoryId,
            name: item.categoryName,
          });
        }
      });

      this.categories = [{ id: 0, name: "全部" }];
      categoryMap.forEach((category) => {
        this.categories.push(category);
      });

      let filteredProducts = this.allProducts;

      if (this.query.name) {
        filteredProducts = filteredProducts.filter(
          (item) =>
            (item.productName && item.productName.includes(this.query.name)) ||
            (item.productCode && item.productCode.includes(this.query.name)) ||
            (item.externalCode && item.externalCode.includes(this.query.name)),
        );
      }

      if (this.showDifferencesOnly) {
        filteredProducts = filteredProducts.filter((item) => {
          return (
            item.inventoryNum === "" ||
            item.inventoryNum == null ||
            Number(item.inventoryNum) < 0
          );
        });
      }

      const grouped = _.groupBy(filteredProducts, "categoryName");

      let resultCategories = [];
      this.categories.forEach((cat) => {
        if (cat.id !== 0 && grouped[cat.name]) {
          resultCategories.push({
            name: cat.name,
            products: grouped[cat.name],
          });
        }
      });

      this.categoriesDetail = resultCategories;

      this.finished = true;
      this.loading = false;
    },

    clickLeft(id) {
      this.query.categoryId = id;
      this.pageIndex = 1;
      this.finished = false;
      this.groupProductsByCategory();

      this.$nextTick(() => {
        const scrollContainer =
          document.querySelector(".rightWrapper") ||
          document.querySelector(".productWrapper");

        const category = this.categories.find((cat) => cat.id === id);

        if (id !== 0 && category && category.name && scrollContainer) {
          const categoryElement = document.getElementById(
            `category-${category.name}`,
          );
          if (categoryElement) {
            scrollContainer.scrollTo({
              top: categoryElement.offsetTop - 10,
              behavior: "smooth",
            });
          }
        } else if (scrollContainer) {
          scrollContainer.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      });
    },

    handleRightScroll(event) {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        const scrollTop = event.target.scrollTop;
        let activeCategoryId = 0;

        for (let i = 0; i < this.categoriesDetail.length; i++) {
          const category = this.categoriesDetail[i];
          const categoryElement = document.getElementById(
            `category-${category.name}`,
          );
          if (categoryElement) {
            const offsetTop = categoryElement.offsetTop;

            if (offsetTop - 50 <= scrollTop) {
              const found = this.categories.find(
                (cat) => cat.name === category.name,
              );
              if (found) {
                activeCategoryId = found.id;
              }
            } else {
              break;
            }
          }
        }

        if (activeCategoryId !== this.query.categoryId) {
          this.query.categoryId = activeCategoryId;
        }
      }, 100);
    },

    getList(list) {
      return list.map((el) => {
        const item = { ...el };

        return item;
      });
    },
    formatDesc(item) {
      return `商品条码：${item.externalCode || "--"}`;
    },
    formatePrice(item) {
      return "￥" + item.retailPrice + (item.unit ? `/${item.unit}` : "");
    },

    toSearch() {
      this.query.name = this.condition;
      this.pageIndex = 1;
      this.finished = false;
      this.groupProductsByCategory();
    },
    clear() {
      this.condition = "";
      this.query.name = "";
      this.pageIndex = 1;
      this.finished = false;
      this.groupProductsByCategory();
    },
    onLoad() {
      this.finished = true;
    },
    handleAdjust(item) {
      const query = {
        planId: this.planId,
        productId: item.productId,
      };
      if (this.$route.query.sheetId) {
        query.sheetId = this.$route.query.sheetId;
        query.type = this.$route.query.type;
      }
      this.$router.push({
        path: "/stock/inventory/adjust",
        query: query,
      });
    },

    handleDelete(item) {
      this.$dialog
        .confirm({
          title: "确认删除",
          message: `确定要删除商品【${item.productName}】吗？`,
        })
        .then(() => {
          if (this.pageType === "edit") {
            const isInInitial = this.initialProducts.some(
              (p) => p.productId === item.productId,
            );
            if (isInInitial) {
              this.deleteProductIds.push(item.productId);
            }
          }
          this.allProducts = this.allProducts.filter(
            (product) => product.productId !== item.productId,
          );
          try {
            const planData = {
              planId: this.planId,
              planCode: this.planCode,
              scId: this.scId,
              storeName: this.storeName,
              allProducts: this.allProducts,
              initialProducts: this.initialProducts,
            };
            localStorage.setItem(
              this.getPlanCacheKey(),
              JSON.stringify(planData),
            );
            // 重新分组，自动更新左侧类目和右侧商品列表
            this.groupProductsByCategory();
          } catch (e) {
            console.warn("更新本地存储失败", e);
          }
        })
        .catch(() => {});
    },

    handleAdjustResult(productId, finalInventoryNum) {
      try {
        const product = this.allProducts.find(
          (item) => item.productId === productId,
        );
        if (product) {
          product.inventoryNum = finalInventoryNum;

          this.savePlanToCache();

          this.groupProductsByCategory();
        }
      } catch (e) {
        console.error("调整库存失败:", e);
        this.$toast.error("调整库存失败");
      }
    },
    toAdjust() {
      this.showDifferencesOnly = !this.showDifferencesOnly;
      this.groupProductsByCategory();
    },

    toScan() {
      this.scanDialogVisible = true;
      this.scanBuffer = "";
      // 禁用所有输入法，包括数字键盘
      document.body.contentEditable = "false";

      document.addEventListener("keydown", this.handleExternalCodeInput, true);

      this.createHiddenInput();
    },

    closeScan() {
      this.scanDialogVisible = false;
      this.scanBuffer = "";

      document.removeEventListener(
        "keydown",
        this.handleExternalCodeInput,
        true,
      );

      this.removeHiddenInput();
    },

    createHiddenInput() {
      let hiddenInput = document.getElementById("scan-hidden-input");
      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.id = "scan-hidden-input";
        hiddenInput.type = "text";
        hiddenInput.style.cssText =
          "position:fixed;top:-1000px;left:-1000px;width:1px;height:1px;opacity:0;";
        document.body.appendChild(hiddenInput);
        hiddenInput.addEventListener("input", this.handleScanInput);
      }
      hiddenInput.value = "";
      setTimeout(() => hiddenInput.focus(), 50);
    },

    removeHiddenInput() {
      const hiddenInput = document.getElementById("scan-hidden-input");
      if (hiddenInput) {
        hiddenInput.removeEventListener("input", this.handleScanInput);
        hiddenInput.remove();
      }
    },

    handleScanInput(event) {
      const code = event.target.value.trim();

      if (this.scanInputTimer) {
        clearTimeout(this.scanInputTimer);
      }

      if (code && code.length >= 4) {
        this.scanInputTimer = setTimeout(() => {
          if (code.length <= 20) {
            this.processScannedCode(code);
            event.target.value = "";
            this.scanBuffer = "";
          }
        }, 150);
      }
    },
    handleScanEnter() {
      if (this.scanBuffer) {
        if (this.scanBuffer.length >= 4 && this.scanBuffer.length <= 20) {
          this.processScannedCode(this.scanBuffer);
        } else {
          this.$toast.fail("条码有误，请重新扫描:" + this.scanBuffer);
        }
        this.scanBuffer = "";
      }
    },

    handleExternalCodeInput(event) {
      let key = event.key;
      if (!key && event.keyCode) {
        if (event.keyCode >= 48 && event.keyCode <= 57) {
          key = String.fromCharCode(event.keyCode);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
          key = String.fromCharCode(event.keyCode);
        } else if (event.keyCode >= 97 && event.keyCode <= 122) {
          key = String.fromCharCode(event.keyCode);
        }
      }

      if (key && key.length === 1) {
        if (/^[a-zA-Z0-9]$/.test(key)) {
          this.scanBuffer += key;
          event.preventDefault();
        }
      } else if (key === "Enter" || event.keyCode === 13) {
        this.handleScanEnter();
        event.preventDefault();
      }
    },

    processScannedCode(code) {
      const product = this.allProducts.find(
        (item) =>
          (item.productCode && item.productCode === code) ||
          (item.externalCode && item.externalCode === code),
      );

      if (product) {
        this.closeScan();
        this.handleAdjust(product);
      } else {
        this.$toast.fail(`该商品不在盘点单中`);
      }
    },

    searchAndAddProduct(code) {
      reqProduct({ externalCode: code, available: true })
        .then((res) => {
          if (
            res.code === 200 &&
            res.data &&
            res.data.datas &&
            res.data.datas.length > 0
          ) {
            const data = res.data.datas[0];
            const foundProduct = {
              productCode: data.code,
              externalCode: data.externalCode,
              productName: data.name,
              available: data.available,
              unit: data.unit,
              productId: data.id,
              retailPrice: data.retailPrice,
              purchasePrice: data.purchasePrice,
              categoryId: data.categoryId,
              categoryName: data.categoryName,
              brandId: data.brandId,
              brandName: data.brandName,
              skuCode: data.skuCode,
              productType: data.productType,
            };

            foundProduct.inventoryNum = "";
            this.allProducts.push(foundProduct);

            this.savePlanToCache();

            this.groupProductsByCategory();
            this.closeScan();
          } else if (
            res.code === 200 &&
            (!res.data.datas || res.data.datas.length === 0)
          ) {
            this.$toast.fail(`未找到条码为【${code}】的商品`);
          } else {
            this.$toast.fail("搜索商品失败，请重试");
          }
        })
        .catch(() => {
          this.$toast.fail("搜索商品失败，请重试");
        });
    },

    handleAddProduct() {
      const query = this.$route.query;
      this.$router.replace({
        name: "inventoryCategory",
        query: {
          ...query,
          planId: this.planId,
        },
      });
    },

    handleSave() {
      this.submitting = true;
      console.log(this.initialProducts);
      if (this.pageType === "edit") {
        const changedProducts = [];
        this.allProducts.forEach((current) => {
          const initial = this.initialProducts.find(
            (item) => item.productId === current.productId,
          );
          console.log(current, "--", initial);
          const currentInventoryNum = String(current.inventoryNum);
          const initialInventoryNum = initial
            ? String(initial.inventoryNum)
            : "";
          console.log(currentInventoryNum, "--", initialInventoryNum);
          if (currentInventoryNum !== initialInventoryNum) {
            changedProducts.push({
              productId: current.productId || current.id,
              takeNum:
                current.inventoryNum === 0 || current.inventoryNum
                  ? String(current.inventoryNum)
                  : "",
              description: "",
            });
          }
        });

        const data = {
          id: this.sheetId,
          description: this.description,
          deleteProductIds: this.deleteProductIds,
          products: changedProducts,
        };
        update(data)
          .then((res) => {
            this.submitting = false;
            if (res.code === 200) {
              this.$toast.success("保存成功");

              this.updateCache();

              this.handleClose();
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$toast.fail("保存失败，请重试");
          });
      } else {
        const data = {
          planId: this.planId,
          preSheetId: "",
          description: this.description,
          products: this.allProducts.map((item) => ({
            productId: item.productId || item.id,
            takeNum:
              item.inventoryNum === 0 || item.inventoryNum
                ? String(item.inventoryNum)
                : "",
            description: "",
          })),
        };
        create(data)
          .then((res) => {
            this.submitting = false;
            if (res.code === 200) {
              this.$toast.success("保存成功");
              this.updateCache();
              this.handleClose();
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$toast.fail("保存失败，请重试");
          });
      }
    },

    handleApprove() {
      const zeroCount = this.allProducts.filter((item) => {
        const num = Number(item.inventoryNum);
        return item.inventoryNum === "" || item.inventoryNum == null || num < 0;
      }).length;
      if (zeroCount > 0) {
        this.$toast(
          ` ${zeroCount} 个商品未填写盘点数或盘点数量小于0，请尽快核对并补填正确数量`,
        );
      } else {
        this.doApprove();
      }
    },

    doApprove() {
      this.submitting = true;

      if (this.$route.query.sheetId) {
        const updateData = {
          planId: this.planId,
          id: this.sheetId,
          description: this.description,
          products: this.allProducts.map((item) => ({
            productId: item.productId || item.id,
            takeNum:
              item.inventoryNum === 0 || item.inventoryNum
                ? String(item.inventoryNum)
                : "",
            description: "",
          })),
        };

        update(updateData)
          .then((res) => {
            if (res.code === 200) {
              const approveData = {
                id: this.sheetId,
              };
              approvePass(approveData)
                .then((approveRes) => {
                  this.submitting = false;
                  if (approveRes.code === 200) {
                    this.clearCache();
                    this.handleClose();
                  }
                })
                .catch((e) => {
                  console.error("审核通过失败:", e);
                  this.submitting = false;
                  this.$toast.fail("审核通过失败，请重试");
                });
            } else {
              this.submitting = false;
              this.$toast.fail("审核通过失败，请重试");
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$toast.fail("保存盘点数据失败，请重试");
          });
      } else {
        const data = {
          planId: this.planId,
          preSheetId: "",
          description: this.description,
          products: this.allProducts.map((item) => ({
            productId: item.productId || item.id,
            takeNum:
              item.inventoryNum === 0 || item.inventoryNum
                ? String(item.inventoryNum)
                : "",
            description: "",
          })),
        };
        directApprovePass(data)
          .then((res) => {
            this.submitting = false;
            if (res.code === 200) {
              this.clearCache();
              this.handleClose();
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$toast.fail("审核通过失败，请重试");
          });
      }
    },

    handleClose() {
      this.initialProducts = [];
      this.deleteProductIds = [];
      this.$router.push("/stock/inventory");
    },

    updateCache() {
      this.savePlanToCache();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.description {
  background-color: #fff;
  .van-cell {
    padding: 5px 5px 5px 15px;
    ::v-deep .van-field__label {
      width: 3rem !important;
    }
    ::v-deep .van-field__body {
      border: #d0d0d0 1px solid;
    }
  }
}
::v-deep .van-card__price {
  width: 100%;
}
::v-deep .van-search__action {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex: 1;
}
#inventory-goods {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.listWrapper {
  display: flex;
  flex: 1;
  overflow: hidden;

  .leftWrapper {
    width: 5rem;
    overflow-y: auto;
    background: #f7f8fa;
  }

  .rightWrapper {
    flex: 1;
    overflow-y: auto;
    padding: 0 10px;
    position: relative;

    .productWrapper {
      padding-bottom: 120px;
    }

    .categoryTitle {
      padding: 8px 0;
      color: #666;
      font-weight: 500;
    }

    .van-card {
      margin-bottom: 10px;
    }

    .emptyWrapper {
      text-align: center;
      padding-top: 50px;
      color: #999;
    }
  }
}

.inventory-num {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .stock-info {
    display: flex;
    align-items: center;
    gap: 4px;

    .stock-label {
      font-size: 13px;
      color: #666;
    }

    .stock-value {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
}

.action-links {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 8px;
  width: 100%;

  .action-link {
    font-size: 14px;
    color: #1989fa;
    cursor: pointer;

    &.delete {
      color: #ee0a24;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  .divider {
    color: #d9d9d9;
    font-size: 14px;
  }
}

.product-title {
  display: inline-block;
  vertical-align: middle;
}

.weight-badge {
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background-color: #ff6b00;
  border-radius: 50%;
}

/* 扫码弹窗样式 */
.scan-popup {
  border-radius: 16px;
  overflow: hidden;
}

.scan-dialog {
  padding: 30px 20px;
  text-align: center;
}

.scan-icon-wrapper {
  margin-bottom: 20px;
}

.scan-tip {
  margin-top: 12px;
  font-size: 16px;
  color: #666;
}

.scan-actions {
  margin-top: 30px;
}

/* 底部操作按钮 */
.footer-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 10px 15px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.footer-btn-group {
  display: flex;
  gap: 10px;
  ::v-deep .van-button--normal {
    padding: 0 4px;
    font-size: 12px;
  }
}

.footer-btn-group .van-button {
  flex: 1;
}

.numChangeBox {
  display: flex;
  align-items: center;
  gap: 4px;

  .circleIcon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .numInput {
    width: 50px;
    text-align: center;

    :deep(.van-cell__left) {
      width: 100%;
    }

    :deep(.van-field__control) {
      text-align: center;
      font-size: 14px;
    }
  }
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 15px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

  .van-button {
    height: 44px;
    font-size: 16px;
  }
}

::v-deep .van-list {
  height: 100%;
  overflow: auto;
}

/* 全屏禁用蒙层 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 9999;
  pointer-events: all;
}

#inventory-goods {
  position: relative;
  min-height: 100vh;
}
</style>
